import React from 'react'

const HistoryFilter = ({
  search,
  setSearch,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  handleSearch,
  handleResetSearch,
  activeSearch,
  renderSearchText
}) => {
  return (
    <>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Cari Kode Transaksi / Produk"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.9em', flex: '1', minWidth: '140px', outline: 'none' }}
        />
        <input
          type="date"
          placeholder="Tanggal Mulai"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.9em', minWidth: '130px', outline: 'none' }}
        />
        <input
          type="date"
          placeholder="Tanggal Akhir"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.9em', minWidth: '130px', outline: 'none' }}
        />
        <button
          onClick={handleSearch}
          style={{ padding: '8px 16px', background: '#00a651', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9em', outline: 'none' }}
        >
          Cari
        </button>
        <button
          onClick={handleResetSearch}
          style={{ padding: '8px 16px', background: '#f5f5f5', color: '#555', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9em', outline: 'none' }}
        >
          Reset
        </button>
      </div>

      {activeSearch && (activeSearch.search || activeSearch.startDate || activeSearch.endDate) && (
        <div style={{ marginBottom: '15px', fontSize: '0.9em', color: '#333', fontStyle: 'italic', background: '#eefcf4', padding: '10px 14px', borderRadius: '6px', border: '1px solid #b7edd0' }}>
          {renderSearchText()}
        </div>
      )}
    </>
  )
}

export default HistoryFilter
